import { fromFetch } from 'rxjs/fetch';
import {
  totalDeliveryValueCommunityLogger,
  totalDeliveryValuePlanLogger,
  totalDeliveryValueSpecLogger,
} from 'constants/routes';

export const postCommunityLogger$ = (payload) => {
  const requestObject = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...payload,
    }),
    selector: (response) => response.text(),
  };

  return fromFetch(totalDeliveryValueCommunityLogger, requestObject);
};

export const postPlanLogger$ = (payload) => {
  const requestObject = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...payload,
    }),
    selector: (response) => response.text(),
  };

  return fromFetch(totalDeliveryValuePlanLogger, requestObject);
};

export const postSpecLogger$ = (payload) => {
  const requestObject = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...payload,
    }),
    selector: (response) => response.text(),
  };

  return fromFetch(totalDeliveryValueSpecLogger, requestObject);
};
